import { Box } from '@zillow/constellation-10';
import { styled } from '@/styled-system/jsx';

const footerHeight = '94px';

// Reusable variant configuration: Displays on mobile, hides at specified breakpoint
const mobileViewVariants = {
  showDesktopViewBreakpoint: {
    md: {
      md: {
        display: 'none',
      },
    },
    xl: {
      xl: {
        display: 'none',
      },
    },
    xxl: {
      xxl: {
        display: 'none',
      },
    },
  },
} as const;

// Reusable variant configuration: Hides on mobile, displays at specified breakpoint
const desktopViewVariants = {
  showDesktopViewBreakpoint: {
    md: {
      mdDown: {
        display: 'none',
      },
    },
    xl: {
      xlDown: {
        display: 'none',
      },
    },
    xxl: {
      xxlDown: {
        display: 'none',
      },
    },
  },
} as const;

export const StyledWizardTipCardContainerMobile = styled(Box, {
  base: {
    display: 'block',
  },
  variants: mobileViewVariants,
});

export const StyledWizardTipCardContainerDesktop = styled(Box, {
  base: {
    display: 'block',
  },
  variants: desktopViewVariants,
});

export const StyledContentContainer = styled(Box, {
  base: {
    height: '100%',
    borderTop: '1px solid {colors.border.subtle}',
    borderBottom: 'none',
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingInline: '400',
    lg: {
      paddingInline: '600',
      borderBottom: '1px solid {colors.border.subtle}',
      marginBottom: 0,
    },
    xxl: {
      paddingInline: '104px',
    },
    '& .content-grid': {
      maxWidth: '1232px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  variants: {
    hideFooter: {
      true: {},
      false: {
        marginBottom: footerHeight,
        lg: {
          marginBottom: 0,
        },
      },
    },
  },
});

export const StyledWizardTipCardContainer = styled(Box, {
  base: {},
  variants: {
    showDesktopViewBreakpoint: {
      md: {
        md: {
          marginLeft: '105px',
        },
      },
      xl: {
        xl: {
          marginLeft: '105px',
        },
      },
      xxl: {
        xxl: {
          marginLeft: '105px',
        },
      },
    },
  },
});

export const StyledMobileGrid = styled(Box, {
  base: {
    display: 'grid',
    gridColumnEnd: 'span 12',
    paddingTop: '600',
    paddingBottom: '200',
    borderTop: '1px solid {colors.border.subtle}',
  },
  variants: mobileViewVariants,
});

export const StyledDesktopContainer = styled(Box, {
  base: {
    display: 'block',
    marginTop: '600',
    marginBottom: '1400',
  },
  variants: desktopViewVariants,
});

export const StyledHeaderContainer = styled(Box, {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBlock: { base: '400', md: '600' },
  },
  variants: {
    showDesktopViewBreakpoint: {
      md: {
        paddingInline: { base: '400', md: '104px' },
      },
      xl: {
        paddingInline: { base: '400', md: '600', xl: '104px' },
      },
      xxl: {
        paddingInline: { base: '400', md: '600', xxl: '104px' },
      },
    },
  },
});
